exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2_Q6rrYCFblD3M{display:inline-block;line-height:1}.z53beXNiDPJAy2 svg{height:16px;width:16px;line-height:16px}._3Dk1GPoKnJxuep svg{height:20px;width:20px;line-height:20px}._1fXLS4oRrPeaIC svg{height:24px;width:24px;line-height:24px}", ""]);

// exports
exports.locals = {
	"nch-icon": "_2_Q6rrYCFblD3M",
	"nch-icon--small": "z53beXNiDPJAy2",
	"nch-icon--medium": "_3Dk1GPoKnJxuep",
	"nch-icon--large": "_1fXLS4oRrPeaIC"
};